<template>
  <div class="expenses-group">
    <template v-if="!branchNotFound">
      <v-data-table
        v-model="selected"
        :fixed-header="true"
        :headers="headers"
        :items="expenses"
        item-key="id"
        class="elevation-1"
        height="65vh"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [50]
        }"
        :loading="isLoadingExpenses"
        loading-text="Loading Expenses... Please wait"
        :search="search"
      >
        <template v-slot:top>
          <div class="d-flex">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              color="primary darken-4"
              single-line
              hide-details
              filled
              clearable
            ></v-text-field>
          </div>

          <v-divider></v-divider>
        </template>

        <template v-slot:item.title="{ item }">
          <div class="mx-auto" v-text="item.title"></div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div class="mx-auto" v-text="item.amount"></div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">{{ item.description }}</td>
        </template>
      </v-data-table>

      <v-fab-transition>
        <v-btn
          v-show="isSmaller"
          dark
          color="primary darken-4"
          fixed
          bottom
          right
          fab
          @click="openAddExpenseDialog()"
        >
          <v-icon large>mdi-cash-minus</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Expenses Group</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ExpensesGroup",
  data() {
    return {
      search: "",
      selected: [],
      isLoadingExpenses: false,
      itemId: "",
      removeItem: null,

      headers: [
        { text: "Title", align: "center", value: "title" },
        { text: "Amount (GH₵)", align: "center", value: "amount" },
        { text: "Description", value: "data-table-expand" }
      ]
    };
  },

  components: {},

  methods: {
    openAddExpenseDialog() {
      this.$store.commit("setAddExpenseDialog", true);
    },

    async getExpensesGroup() {
      var groupId = this.$route.params.groupId;

      this.isLoadingExpenses = true;

      await this.$store.dispatch("getExpensesGroup", groupId).finally(() => {
        this.isLoadingExpenses = false;
      });
    },

    setSnackbar(msg, color) {
      var payload = {
        state: true,
        color: color,
        comment: msg
      };
      this.$store.commit("setSnackbar", payload);
    }
  },

  watch: {
    $route() {
      this.getExpensesGroup();
    },

    removeItem: "deleteItem"
  },

  mounted() {
    this.getExpensesGroup();
  },

  computed: {
    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    expenses() {
      return this.$store.state.analyses.expenses;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    isSmaller() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs" || name === "sm") return true;
      else return false;
    }
  }
};
</script>

<style>
</style>